import { render, staticRenderFns } from "./Userprofile.vue?vue&type=template&id=38e2cd9d&scoped=true"
import script from "./Userprofile.vue?vue&type=script&lang=js"
export * from "./Userprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2cd9d",
  null
  
)

export default component.exports